import React from 'react';
import logo from './logo.svg';
import './App.css';
import PropType from 'prop-types';
import { tsPropertySignature } from '@babel/types';
import ProgressBar from 'react-bootstrap/ProgressBar'
import FlipMove from 'react-flip-move';
import Dropdown from 'react-bootstrap/Dropdown'
//import {bounce} from 'react-animations';
 
class Mylist extends React.Component{
  constructor(props){
    super(props)
    this.state={list:[],newitem:"",len:0,date:""}
     }

getValue(e){
  console.log(e.target.value)
  let date1=this.state.date;
  var date = new Date().getDate();
var month = new Date().getMonth() + 1; 
var year = new Date().getFullYear(); 
var hours = new Date().getHours(); 
var min = new Date().getMinutes(); 
var sec = new Date().getSeconds();
date1 = date + '/' + month + '/' + year + ' ' + hours + ':' + min + ':' + sec
  this.setState({
newitem:e.target.value,date:date1
  })
}
setValue(e){
 var obj={name:this.state.newitem,status:false,date2:this.state.date}
  if(this.state.newitem.trim())
  {
  let item=this.state.list
  item.push(obj)
  this.setState(
    {list:item,newitem:""})
  }
}
namesort(){
  let arrsort =this.state.list;
  let t= arrsort.sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  this.setState({list:t})
}

datesort(){
  let dtsort=this.state.list;
  let a=dtsort.sort((a,b) => a.date > b.date ? -1 : a.date < b.date ?1:0)
  this.setState({list:a})
}

getlist(){
  var arr=[]
  for(let i=0;i<this.state.list.length;i++){
  arr.push( 
  <div className="container margin1 flex  " key={i}>  
  
  <button  onClick={()=>this.setstatus(i)} onDoubleClick={()=>this.topitem(i)} 
className={this.state.list[i].status?"btn btn-outline btn-block btn-success ":"btn btn-outline btn-block border"}>{this.state.list[i].name}{this.state.list[i].date2} </button>
  <button className=" btn btn-warning " onClick={()=>this.upitem(i)}>up</button>   
  <button className=" btn btn-info  " onClick={()=>this.downitem(i)}>down</button>   
  <button className="btn btn-danger " onClick={()=>this.deleteitem(i)} >X</button> 
  
  </div>
  )}
  return arr
}

upitem=(i)=>{
  let lo=this.state.list;
  if(i>0){
  [lo[i],lo[i-1]]=[lo[i-1],lo[i]];
  this.setState({
    list:lo
  })
}
}

topitem=(i)=>{
  let ls=this.state.list;
    [ls[i],ls[0]]=[ls[0],ls[i]];
    this.setState({
      list:ls
    })
  }

downitem=(i)=>{
  let lo=this.state.list;
  if(i<this.state.list.length-1){
  [lo[i],lo[i+1]]=[lo[i+1],lo[i]];
  this.setState({
    list:lo
  })
}
}

setstatus=(i)=>{
  let l=this.state.list
  if(l[i].status==true){
    this.state.len-=1
}
  else{
    this.state.len+=1
}
l[i].status=!l[i].status  
this.setState({ list:l })

}

deleteitem=(i)=>{
  let l=this.state.list
  if(l[i].status==true){
    this.state.len-=1
  }
  l.splice(i,1);
  this.setState({
    list:l
  })
}

render(){
  return(
    <div>
      <div className="text-center" ><br/>
        <h3  class="animated infinite bounce delay-2s"><strong>TODO LIST</strong></h3><br/>
    <button className=" btn btn-info" onClick={this.setValue.bind(this)}> ADD </button><br/><br/>
     <input  onChange={this.getValue.bind(this)} value={this.state.newitem} placeholder="enter task"/><br/><br/><h4>totol item={this.state.list.length}</h4>
     <br/>
     <h4 className="font-weight-light-center" >Completed items = {this.state.len}</h4><br/>
     <br/><ProgressBar animated now={(this.state.len/this.state.list.length)*100}  label={`${(this.state.len/this.state.list.length)*100}%`} /><br/>
     <ul className="list group"><FlipMove>{this.getlist()}</FlipMove></ul><br/>
     <Dropdown>
  <Dropdown.Toggle variant="primary" id="dropdown-basic">
    Sort By
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item href="#/action-1" onClick={()=>this.datesort()}>Date</Dropdown.Item>
    <Dropdown.Item href="#/action-2" onClick={()=>this.namesort()}>name</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>

    </div>
    </div>
  )
}
}
function Parent(props){
    return (
      <div>
     <Mylist list={[1,2,3,4]}></Mylist>
     
    </div> 
    ); 
  }
  export  default Parent;



